
export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-r from-[#003366] to-[#005A8C] relative overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 relative z-10">
        {/* 限定感ブロック */}
        <div className="bg-[#00A651] text-white px-6 py-3 rounded-full inline-block mb-6 font-bold text-sm animate-pulse">
          <i className="ri-flashlight-line mr-2"></i>
          最短5分でカード番号発行！
        </div>

        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            今すぐ地方銀行系スピード発行カードに申し込む
          </h2>
          
          {/* キャンペーン情報 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-6 border-2 border-white/30">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-speed-line text-4xl text-[#00A651]"></i>
              <div className="text-left">
                <p className="text-white/90 text-sm">スピード発番サービス</p>
                <p className="text-3xl font-bold text-white">最短5分で発行</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#00A651] font-bold mb-1">特典①</p>
                <p className="text-white">初年度<br />年会費無料</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#00A651] font-bold mb-1">特典②</p>
                <p className="text-white">最短5分で<br />カード番号発行</p>
              </div>
              <div className="bg-white/10 rounded-lg p-3">
                <p className="text-[#00A651] font-bold mb-1">特典③</p>
                <p className="text-white">スマホ保険<br />年間最高3万円</p>
              </div>
            </div>
          </div>

          <a
            href="https://www.suruga-card.co.jp/lp/jcb_supihatsu/index.html"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#B91C1C] text-white font-bold px-12 py-5 rounded-full transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer text-lg md:text-xl mb-4"
          >
            <i className="ri-external-link-line text-xl"></i>
            公式サイトで今すぐ申し込む（PR）
          </a>

          {/* 安心ポイント */}
          <div className="flex flex-wrap justify-center gap-4 text-white/90 text-sm mb-4">
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#00A651]"></i>
              <span>初年度年会費無料</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#00A651]"></i>
              <span>受付時間9:00〜20:00</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-check-line text-[#00A651]"></i>
              <span>即日ネット決済可能</span>
            </div>
          </div>

          <p className="text-white/70 text-xs">
            ※スピード発番の受付時間：9:00〜20:00（年中無休）
          </p>
        </div>
      </div>
    </section>
  );
}
